var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pin-form" }, [
    _vm.allowUserScope && !_vm.lockedDeviceSerial
      ? _c(
          "div",
          { staticClass: "pin-form__row pin-form__row--toggle" },
          [
            _c(
              "el-checkbox",
              {
                attrs: { disabled: _vm.saving },
                model: {
                  value: _vm.applyToAllUserDevices,
                  callback: function ($$v) {
                    _vm.applyToAllUserDevices = $$v
                  },
                  expression: "applyToAllUserDevices",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("otaPin.pinForAllUserCanes")) + " ")]
            ),
            _c("span", { staticClass: "pin-form__hint" }, [
              _vm._v(" " + _vm._s(_vm.$t("otaPin.userScopeHint")) + " "),
            ]),
          ],
          1
        )
      : _vm._e(),
    !_vm.lockedDeviceSerial
      ? _c(
          "div",
          { staticClass: "pin-form__row" },
          [
            _c("span", { staticClass: "pin-form__label" }, [
              _vm._v(_vm._s(_vm.$t("otaPin.device"))),
            ]),
            _c(
              "el-select",
              {
                staticStyle: { width: "320px" },
                attrs: {
                  placeholder: _vm.$t("otaPin.selectDevice"),
                  size: "small",
                  disabled: _vm.applyToAllUserDevices || _vm.saving,
                },
                on: { change: _vm.onDeviceChange },
                model: {
                  value: _vm.selectedSerial,
                  callback: function ($$v) {
                    _vm.selectedSerial = $$v
                  },
                  expression: "selectedSerial",
                },
              },
              _vm._l(_vm.userDevices, function (d) {
                return _c(
                  "el-option",
                  { key: d.serial_number, attrs: { value: d.serial_number } },
                  [
                    _c("span", [_vm._v(_vm._s(d.serial_number))]),
                    d === _vm.userDevices[0]
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#67c23a",
                              "font-size": "11px",
                              "margin-left": "6px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("otaPin.lastConnected")))]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              1
            ),
            !_vm.userDevices.length
              ? _c("span", { staticClass: "pin-form__warn-text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("otaPin.noActiveDevice")) + " "),
                ])
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "pin-form__row" },
          [
            _c("span", { staticClass: "pin-form__label" }, [
              _vm._v(_vm._s(_vm.$t("otaPin.device"))),
            ]),
            _c("code", { staticClass: "pin-form__locked" }, [
              _vm._v(_vm._s(_vm.lockedDeviceSerial)),
            ]),
            _c(
              "el-tag",
              {
                staticStyle: { "margin-left": "6px" },
                attrs: { size: "mini", type: "info" },
              },
              [_vm._v(_vm._s(_vm.$t("otaPin.locked")))]
            ),
          ],
          1
        ),
    _vm.applyToAllUserDevices
      ? _c("div", { staticClass: "pin-form__hint-block" }, [
          _vm._v(" " + _vm._s(_vm.$t("otaPin.allCanesHint")) + " "),
        ])
      : _vm.effectiveCaneVersion
      ? _c(
          "div",
          { staticClass: "pin-form__hint-block" },
          [
            _vm._v(" " + _vm._s(_vm.$t("otaPin.version")) + " "),
            _c("strong", [_vm._v(_vm._s(_vm.effectiveCaneVersion))]),
            _c("i18n", {
              attrs: { path: "otaPin.onlyMajorPinnable", tag: "span" },
              scopedSlots: _vm._u([
                {
                  key: "range",
                  fn: function () {
                    return [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.effectiveCaneVersion === "V2"
                              ? "2.x.x"
                              : "3.x.x"
                          )
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm.existingPin
              ? _c(
                  "el-tag",
                  {
                    staticStyle: { "margin-left": "8px" },
                    attrs: { type: "warning", size: "mini" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("otaPin.alreadyPinned", {
                            version: _vm.existingPin.appVersion,
                          })
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm.selectedSerial
      ? _c(
          "div",
          { staticClass: "pin-form__warn-block" },
          [
            _c("strong", [_vm._v("⚠ " + _vm._s(_vm.$t("otaPin.cannotPin")))]),
            _c("i18n", {
              attrs: { path: "otaPin.serialFormatMismatch", tag: "span" },
              scopedSlots: _vm._u([
                {
                  key: "serial",
                  fn: function () {
                    return [_c("code", [_vm._v(_vm._s(_vm.selectedSerial))])]
                  },
                  proxy: true,
                },
                {
                  key: "format",
                  fn: function () {
                    return [_c("code", [_vm._v("WW-OZ-XXXX{5/6/7}-XXXXXX")])]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.canShowOtaPicker
      ? _c(
          "div",
          { staticClass: "pin-form__row pin-form__row--actions" },
          [
            !_vm.lockedOtaFile
              ? _c(
                  "el-select",
                  {
                    staticStyle: { width: "280px" },
                    attrs: {
                      placeholder: _vm.$t("otaPin.selectOtaVersion"),
                      size: "small",
                      filterable: "",
                      disabled: _vm.saving,
                    },
                    model: {
                      value: _vm.selectedOtaFileId,
                      callback: function ($$v) {
                        _vm.selectedOtaFileId = $$v
                      },
                      expression: "selectedOtaFileId",
                    },
                  },
                  _vm._l(_vm.filteredOtaFiles, function (f) {
                    return _c("el-option", {
                      key: f.id,
                      attrs: { label: _vm.otaLabel(f), value: f.id },
                    })
                  }),
                  1
                )
              : _c("span", { staticClass: "pin-form__locked-ota" }, [
                  _c("strong", [_vm._v("OTA:")]),
                  _vm._v(" " + _vm._s(_vm.otaLabel(_vm.lockedOtaFile)) + " "),
                ]),
            _c("el-input", {
              staticStyle: { width: "320px", "margin-left": "8px" },
              attrs: {
                placeholder: _vm.$t("otaPin.reasonPlaceholder"),
                size: "small",
                disabled: _vm.saving,
              },
              model: {
                value: _vm.reason,
                callback: function ($$v) {
                  _vm.reason = $$v
                },
                expression: "reason",
              },
            }),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "8px" },
                attrs: {
                  type: "primary",
                  size: "small",
                  loading: _vm.saving,
                  disabled: !_vm.canSubmit,
                },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.existingPin
                        ? _vm.$t("otaPin.updatePin")
                        : _vm.$t("otaPin.pin")
                    ) +
                    " "
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }